import { useContext } from "react";
import { AppLoadingContext } from "./AppLoadingContext";

export const useAppLoading = () => {
  const { isAppLoading, setIsAppLoading } = useContext(AppLoadingContext);
  return { isAppLoading, setIsAppLoading };
};
